const Match = require('@/tbs/model/to/Match')
const match = new Match

const tbs_model_vo_MatchBrand = function() {
}

tbs_model_vo_MatchBrand.prototype = {
    /* The view object name */
    name: 'matchBrand',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getBrandMatchList',
            basePath: 'data.list',
            rule: {
                id: '$id',
                organizationId: 'orgId',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',   
                crowd: '$catalog',
                crowdLabel: 'catalog',
                sessionTotal: 'matchCount',
                sessionMax: 'maxTerm',
                gameTotal: 'gameCount'
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getBrandMatch',
            basePath: 'data.brand',
            rule: {
                id: '$id',
                organizationId: 'orgId',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',   
                crowd: '$catalog',
                crowdLabel: 'catalog'
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateBrandMatch',
            basePath: '',
            rule: {
                orgId: 'organizationId',
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                sportType: 'sportType',
                catalog: '$crowd'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'updateBrandMatch',
            basePath: '',
            rule: {
                id: 'id',
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                sportType: 'sportType',
                catalog: '$crowd'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'deleteBrandMatch',
            basePath: '',
            rule: {
                id: 'id'
            }
        },
    },
    renderId: function(id) {
        return id.toString()
    },
    formatCatalog: function(crowd) {
        const crowdOptions = this.crowdOptions
        for (let i = 0; i < crowdOptions.length; i++) {
            let crowdOption = crowdOptions[i]
            if (crowdOption.value == crowd) {
                return crowdOption.label
            }
        }
        return ''
    },
    renderCrowd: function(catalog) {
        // console.log('@renderCrowdLabel', matchBrandCrowd)
        const crowdOptions = this.crowdOptions
        for (let i = 0; i < crowdOptions.length; i++) {
            let crowdOption = crowdOptions[i]
            if (crowdOption.label == catalog) {
                return crowdOption.value
            }
        }
        return ''
    },
    crowdOptions: [
        { label: match.localeProp('match-brand-crowd-option-1'), value: '1' },
        { label: match.localeProp('match-brand-crowd-option-2'), value: '2' },
        { label: match.localeProp('match-brand-crowd-option-3'), value: '3' },
        { label: match.localeProp('match-brand-crowd-option-4'), value: '4' },
        { label: match.localeProp('match-brand-crowd-option-99'), value: '99' },
    ],
    renderArea: function(country, province, city, district) {
        let area = ''
        if (country && !province) {
            area = country
        }
        else {
            area = province
        }
        if (city) {
            area += ' ' + city
        }
        if (district) {
            area += ' ' + district
        }
        return area
    },
    renderAreaId: function(countryId, provinceId, cityId, districtId) {
        let areaId = countryId
        if (provinceId) {
            areaId = provinceId
        }
        if (cityId) {
            areaId = cityId
        }
        if (districtId) {
            areaId = districtId
        }
        return areaId
    },
}

module.exports = tbs_model_vo_MatchBrand